import { Component, OnInit } from '@angular/core';
import { ViewController, Platform, NavController, NavParams } from 'ionic-angular';
import { Localization } from '../../app/app.localization'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiService } from '../../app/services/api.service';
import { Storage } from '@ionic/storage';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage';

@Component({
  selector: 'select-receive-modal',
  templateUrl: 'select-receive-modal.html',
  providers: [ApiService]
})

export class SelectReceiveModalComponent implements OnInit {
    title: string;
    customHtmlCode: SafeHtml;
    enableReceivingMethod: boolean;
    receiveTypes: string[];
    storeConfig: any;
    menus: Array<Array<{ id: number, title: string, desc: string, thumb: string, price: number, like: number; liked: boolean, sub: any, is_rock: any, is_soldout_rock: any, is_wait_arrival_rock: any }>>;
    chargeMenu: any;
    chargePrice: any;

    leadTimeMin: number;
    intervalTimeMin: number;
    receiveTimesText: any;
    bottomButton: boolean;

    constructor(
        public platform: Platform,
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        public navParams: NavParams,
        private _loc: Localization,
        private sanitizer: DomSanitizer,
        private _apiService: ApiService,
        private _okageStorage: OkageStorageProvider,
        private storage: Storage
    ) {
        this.title = navParams.get('title') ? navParams.get('title') : "";
        this.customHtmlCode = navParams.get('customHtmlCode') ? sanitizer.bypassSecurityTrustHtml(navParams.get('customHtmlCode')) : "";

        this.enableReceivingMethod = navParams.get('isReceivingMethod') ? true : false;
        if (this.enableReceivingMethod) {
            this.storeConfig = JSON.parse(localStorage.getItem('configs'));
             // メニューから配送料の値を取得
            let chargeMenuId = this.storeConfig['MOBILEORDER_DELIVERY_CHARGE_MENU_ID'];
            if (chargeMenuId) {
                this.storage.get('foods.menu').then((v) => {
                    if (v) {
                        this.menus = v;
                        for (let a = 0; a < this.menus.length; a++) {
                            for (let b = 0; b < this.menus[a].length; b++) {
                                if (this.menus[a][b].id === chargeMenuId) {
                                    this.chargeMenu = this.menus[a][b];
                                    this.chargePrice = this.menus[a][b].price;
                                    break;
                                }
                            }
                        }
                    }
                });
            }
          this.receiveTypes = this.setReceivingTypes();
        }
    }

    closeModal(data: any) {
        this.viewCtrl.dismiss(data);
    }

    ngOnInit() {
    }

    setReceivingTypes() {
        let receiveTypes = [];
        let getType = this.navParams.get('receiveTypes');
        let enableOrderCount = 0;

        for (let i = 0; i < getType.length; i++) {
            if (getType[i] === 'takeout') {
                receiveTypes.push(
                    {
                        text: 'お店で受け取り',
                        method: 'takeout',
                        enableOrderTime: this.enableOrder(getType[i])
                    }
                )
            } else if (getType[i] === 'delivery') {
                receiveTypes.push(
                    {
                        text: 'ご指定の住所にお届け',
                        method: 'delivery',
                        enableOrderTime: this.enableOrder(getType[i])
                    }
                )
            }
            if(receiveTypes[i].enableOrderTime === '') enableOrderCount++;
        }
        enableOrderCount == 0 ? this.bottomButton = true : this.bottomButton = false;
        return receiveTypes;
    }

    // 受付可能な時間外の場合は受付可能な時間を返す
    enableOrder(type) {
        let now = new Date();
        let storeOpen = '';
        let storeOpenHour = this.storeConfig['MOBILEORDER_OPEN_AT'];
        let storeOpenMin = this.storeConfig['MOBILEORDER_OPEN_AT_MIN'];
        let waitMinutes;
        let leadTimeMin;
        let intervalTimeMin;
        let limitTimeHour;
        let limitTimeMin;
        let timeRule;
        this.receiveTimesText = "";

        if(!storeOpenMin) {
          storeOpen = storeOpenHour+':00';
        } else {
          storeOpen = storeOpenHour+':'+storeOpenMin;
        }

        // テイクアウトかデリバリーかでconfigから必要な値を取得
        if (type === 'takeout') {
            waitMinutes = this.storeConfig["OKAGEGO_CURRENT_WAIT_MINUTES"];
            leadTimeMin = this.storeConfig["MOBILEORDER_LEAD_TIME_MIN"];
            intervalTimeMin = this.storeConfig["MOBILEORDER_INTERVAL_TIME_MIN"];
            limitTimeHour = this.storeConfig['MOBILEORDER_LIMIT_TIME_HOUR'];
            limitTimeMin = this.storeConfig['MOBILEORDER_LIMIT_TIME_MIN'];
            timeRule = this.storeConfig["MOBILEORDER_RECEIVE_TIMERULE"];
        } else if (type === 'delivery') {
            waitMinutes = this.storeConfig["OKAGEGO_DELIVERY_WAIT_MINUTES"];;
            leadTimeMin = this.storeConfig["MOBILEORDER_DELIVERY_LEAD_TIME_MIN"];
            intervalTimeMin = this.storeConfig["MOBILEORDER_DELIVERY_INTERVAL_TIME_MIN"];
            limitTimeHour = this.storeConfig['MOBILEORDER_DELIVERY_LIMIT_TIME_HOUR'];
            limitTimeMin = this.storeConfig['MOBILEORDER_DELIVERY_LIMIT_TIME_MIN'];
            timeRule = this.storeConfig["MOBILEORDER_DELIVERY_RECEIVE_TIMERULE"];
        }

        if (type === 'delivery' && waitMinutes === '-1') {
            return "配達の注文受付を停止中";
        }

        var defaultLeadTimeMin = (leadTimeMin)
            ? parseInt(leadTimeMin)
            : 30;

        // 待ち時間 - DDSで待ち時間を設定した場合は（CURRENT_WAIT_MINUTES）を設定。その他はデフォルト(MOBILEORDER_LEAD_TIME_MIN)を指定する
        this.leadTimeMin = (waitMinutes && waitMinutes != "")
            ? parseInt(waitMinutes)
            : defaultLeadTimeMin;

        // 受取希望時間の間隔 - 設定値がない場合は30分で固定
        this.intervalTimeMin = (intervalTimeMin && waitMinutes != "")
            ? parseInt(intervalTimeMin)
            : 30;

        // 受取希望時間の間隔最大時間 - 設定値がない場合は現在時間から2時間後
        var dtMax = (limitTimeHour && limitTimeHour != ""
                    && limitTimeMin && limitTimeMin != "")
            ? new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(limitTimeHour), parseInt(limitTimeMin))
            : new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + 240);

        var minute = Math.floor((now.getMinutes() + this.leadTimeMin) / this.intervalTimeMin) * this.intervalTimeMin; // ((現在の分+リードタイム)➗繰り返し時間単位)✖️繰り返し時間単位
        var dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), minute + this.intervalTimeMin);

        // 受取時間間隔が5分未満だったら、受取時間設定の最短時間を5分にする
        if(this.leadTimeMin < 5 && this.intervalTimeMin < 5 ){
            dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), minute + 5);
        }

        // 時間ルールが存在するか
        var receiveTimeRule = (timeRule) ? JSON.parse(timeRule) : "";
        if (timeRule != "" && receiveTimeRule.rules) {
            let finishOrderText = "";
            let enableOrderTime = false;
            let enableOrderText = "";
            let orderTime = [];
            for (let i = 0; i < receiveTimeRule.rules.length; i++) {
                let rule = receiveTimeRule.rules;
                let orderFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate(), rule[i].order.from.substr(0,2), rule[i].order.from.substr(3,2));
                let orderTo = new Date(now.getFullYear(), now.getMonth(), now.getDate(), rule[i].order.to.substr(0,2), rule[i].order.to.substr(3,2));
                orderTime.push({
                    // 分は２桁表示に形成
                    from: orderFrom.getHours()+":"+("0"+orderFrom.getMinutes()).slice(-2),
                    to: orderTo.getHours()+":"+("0"+orderTo.getMinutes()).slice(-2)
                })
                // 営業時間内かどうか
                if (orderFrom.getTime() <= now.getTime() && now.getTime() <= orderTo.getTime()) {
                    enableOrderTime = false;
                    finishOrderText = "";
                    break;
                } else if (now.getTime() < orderFrom.getTime() && now.getTime() < orderTo.getTime()) { // 時間ルールに現在以降の時間で注文可能な時間がある場合
                    enableOrderTime = true;
                    enableOrderText = "現在、注文できません。<br>次回の受付開始時間("+orderTime[i].from+")";
                    break;
                } else { // 営業出来る時間がない場合
                    enableOrderTime = false;
                    finishOrderText = "現在受付時間外です。<br>受付時間("+orderTime[0].from+"〜"+orderTime[0].to+")";
                }
            }
            // 受付時間外か次回注文可能な時間があればテキストに格納
            this.receiveTimesText = enableOrderTime ? enableOrderText : finishOrderText;
        } else {
            if (dt.getTime() > dtMax.getTime()) {
                this.receiveTimesText = "現在受付時間外です。<br>受付時間("+storeOpen+'〜'+limitTimeHour+':'+limitTimeMin+")";
            }
        }
        return this.receiveTimesText;
    }
}



// WEBPACK FOOTER //
// ./src/components/select-receive-modal/select-receive-modal.ts